<template>
  <div class="container container-global">
    <h2>L’implant à l’étonogestrel</h2>
    <div class="content">
      <p>
        Dispositif non biodégradable, radio-opaque, contenant de l’étonogestrel
        destiné à un usage sous-cutané, préchargé dans un applicateur stérile,
        jetable.
      </p>
      <br />
      <span>Mode d’efficacité:</span>
      <ul>
        <li>
          Glaire cervicale : la glaire devient imperméable à la migration des
          spermatozoïdes
        </li>
        <li>Endomètre : atrophie de l’endomètre</li>
        <li>Action antigonadotrope partielle</li>
      </ul>
      <span>Comment la prescrire ? </span>
      <br />
      <br />
      <p>
        Il s’agit d’une méthode contraceptive de longue durée d’action (LARC),
        peu contraignante en terme d’observance. Elle est efficace durant 3 ans,
        y compris chez les femmes obèses.
        <br />
        <br />
        A initier classiquement dans les 3 premiers jours des règles.
        <br />
        <br />
        Sinon le « quickstart » consiste en une initiation à n’importe quel jour
        du cycle (en s’assurant de l’absence de grossesse+++), mais ne montre
        son efficacité qu’au bout du 7ème jour (méthodes barrières dans
        l’intervalle)
        <br />
        <br />
      </p>
      <br />
      <span>Indice de pearl </span>
      <br />
      <br />
      <p>Indice de Pearl 0.05%</p>
      <br />
      <span>Contre-indications: </span>
      <br />
      <br />
      <p>
        Accident thromboembolique veineux évolutif de moins de 6 mois ƒ
        <br />
        <br />
        Pathologie hépatique sévère
        <br />
        <br />
        Cancer du sein ou de l’utérus
        <br />
        <br />
        Hémorragie génitale non expliquée
        <br />
      </p>
      <br />
      <span>Effets secondaires les plus fréquents : </span>
      <ul>
        <li>
          Troubles du cycle (aménorrhée -spotting) – acné - prise de poids
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .content {
    margin-top: 15px;
    p {
      color: $text-color-aigm;
    }
    span {
      color: $dark-pink;
      text-decoration: underline;
    }
    ul {
      margin: 15px auto 15px auto;
      width: 90%;
      li {
        margin-top: 10px;
        color: $text-color-aigm;
      }
    }
  }
}
</style>
